import script from "./SaveButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaveButton.vue?vue&type=script&setup=true&lang=ts"

import "./SaveButton.vue?vue&type=style&index=0&id=3398baa2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3398baa2"]])

export default __exports__